export default __webpack_public_path__ + "static/media/16.e88ef393.png";